import "./App.css";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

function App() {
  return (
    <div className="w-[100%] h-full overflow-x-hidden">
      <Navbar />
      <div className="flex flex-col h-auto w-full bg-gradient-to-b from-gray-900 to-gray-600 bg-gradient-to-r p-[50px] items-center">
        <Home />
        <Skills />
        <Projects />
      </div>
      <Footer />
    </div>
  );
}

export default App;
